import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useCityContext } from '../../context/CityContext';
import { useNotificationsContext } from '../../context/NotificationsContext';
import './Header.css';

export default function Header() {
  const { activeCity } = useCityContext();
  const { getSubscriptionsForCity } = useNotificationsContext();
  const { citySlug } = useParams();
  const [menuOpen, setMenuOpen] = useState(false);

  const subCount = citySlug ? getSubscriptionsForCity(citySlug).length : 0;

  return (
    <header className="site-header">
      <div className="header-inner">
        {/* Logo / City name */}
        <Link
          to={activeCity ? `/${activeCity.slug}` : '/'}
          className="header-logo"
          onClick={() => setMenuOpen(false)}
        >
          <div className="header-logo-mark">
            {activeCity ? activeCity.name.charAt(0) : 'N'}
          </div>
          <div className="header-logo-text">
            <span className="header-app-name">
              Notify {activeCity ? activeCity.name : 'Cities'}
            </span>
            {activeCity && (
              <span className="header-tagline-short">{activeCity.state}</span>
            )}
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="header-nav">
          {activeCity && (
            <>
              <Link
                to={`/${activeCity.slug}`}
                className="header-nav-link"
                onClick={() => setMenuOpen(false)}
              >
                Browse Alerts
              </Link>
              <Link
                to={`/${activeCity.slug}/my-alerts`}
                className="header-nav-link header-nav-link--badge"
                onClick={() => setMenuOpen(false)}
              >
                My Notifications
                {subCount > 0 && (
                  <span className="header-badge">{subCount}</span>
                )}
              </Link>
            </>
          )}
          <Link
            to="/"
            className="header-nav-link header-nav-link--cities"
            onClick={() => setMenuOpen(false)}
          >
            All Cities
          </Link>
          <Link
            to="/admin"
            className="header-nav-link header-nav-link--admin"
            onClick={() => setMenuOpen(false)}
          >
            ⚙ Admin
          </Link>
        </nav>

        {/* Hamburger */}
        <button
          className={`header-hamburger${menuOpen ? ' is-open' : ''}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile nav */}
      {menuOpen && (
        <nav className="header-mobile-nav">
          {activeCity && (
            <>
              <Link to={`/${activeCity.slug}`} className="mobile-nav-link" onClick={() => setMenuOpen(false)}>
                Browse Alerts
              </Link>
              <Link to={`/${activeCity.slug}/my-alerts`} className="mobile-nav-link" onClick={() => setMenuOpen(false)}>
                My Notifications {subCount > 0 && <span className="header-badge">{subCount}</span>}
              </Link>
            </>
          )}
          <Link to="/" className="mobile-nav-link" onClick={() => setMenuOpen(false)}>All Cities</Link>
          <Link to="/admin" className="mobile-nav-link" onClick={() => setMenuOpen(false)}>⚙ Admin</Link>
        </nav>
      )}
    </header>
  );
}
